import localFetch from "@/modules/instances/localFetch";

/**
 * Local/self-hosted mode: API keys are managed directly by the local
 * backend (GET /v1/auth/api-keys), not by Cognee Cloud's control plane.
 * The upstream OSS build ships this as a stub that always returns []
 * ("API keys are managed via the local backend directly" — but nothing
 * actually called it). Wired here to the real endpoint.
 */
export interface ApiKey {
  id: string;
  key: string;
  label: string;
  name: string;
}

export default async function getApiKeys(_instance?: unknown): Promise<ApiKey[]> {
  const response = await localFetch("/v1/auth/api-keys", { method: "GET" });
  const data = await response.json();
  return Array.isArray(data) ? data : [];
}
